import { BillingBaseFile } from "interfaces/Mueller.Business.Models";
import { HTTP_GET, WebApiRequest } from "tools/webservice";
import moment from "moment";

export const getBillingBase = (
    date: string, // value from dropdown, must be something parsable by DateTime
    successCallback: (billingFile: BillingBaseFile) => void,
    mountedRef: { current: boolean }
) =>
    WebApiRequest({
      method: HTTP_GET,
      endpoint: `/customers/invoicing/base/dates/${moment(date).format("YYYY-MM-DD")}`,
      successCallback,
      mountedRef,
    });

export const getBillingMonths = (
    successCallback: (months: string[]) => void,
    mountedRef: { current: boolean }
) =>
    WebApiRequest({
      method: HTTP_GET,
      endpoint: "/customers/invoicing/months",
      successCallback,
      mountedRef,
    });
